// ── Filter selections that survive a tab change or a refresh ────────────────
// Everything lives under one prefix so signing out can drop the lot.

const PREFIX = "pd.ui.";

export const readUi = (key, fallback) => {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeUi = (key, value) => {
  try { localStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* ignore */ }
};

export const clearUi = (key) => {
  try { localStorage.removeItem(PREFIX + key); } catch { /* ignore */ }
};

/** Drop every remembered selection - used on sign out. */
export const clearAllUi = () => {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => localStorage.removeItem(k));
  } catch { /* ignore */ }
};
